<template>
  <div>
    <div class="row margin-T">
      <div class="small-4 columns end">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.trackEntryExit" @change="updateBooleanField('trackEntryExit')" />
          <span>TRACK ENTRY AND EXITS</span>
        </label>
      </div>
      <div class="small-4 columns end">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.showInAppBanner" @change="updateBooleanField('showInAppBanner')" />
          <span>SHOW BANNER IN PROVIDER APP</span>
        </label>
      </div>
      <div class="small-4 columns end">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.pushNotificationToProvUponEntry" @change="updateBooleanField('pushNotificationToProvUponEntry')" />
          <span>PUSH ENTRY NOTIFICATIONS</span>
        </label>
      </div>
      <div class="small-4 columns end">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.isMTechPricing" @change="updateBooleanField('isMTechPricing')" />
          <span>USE MTECH PRICING</span>
        </label>
      </div>
    </div>

    <!-- <div class="row margin-T">
      <div class="small-12">
        <table class="table">
          <tr>
            <td colspan="13" class="table-title">SERVICE RATE SETTINGS</td>
          </tr>
          <tr>
            <td></td>
            <td class="table-label" v-show="isP2P"></td>
            <td class="table-label" v-show="!isP2P">Airport<br/>Fee</td>
            <td class="table-label">Per Mile<br/>Rate</td>
            <td class="table-label">Base Rate</td>
            <td class="table-label">Mileage<br/>Threshold</td>
            <td class="table-label">Flat 2nd<br/>Pax Fee</td>
            <td class="table-label">Flax Add.<br/>Pax Fee</td>
            <td class="table-label">Max Pax</td>
            <td class="table-label">Max Bags</td>
            <td colspan="2" class="table-label">Discount</td>
            <td colspan="2" class="table-label">Roundtrip</td>
          </tr>
          <tr>
            <td class="table-label">{{ serviceLabel('shared') }}</td>
            <td v-show="isP2P"></td>
            <td v-show="!isP2P"><vue-autonumeric v-model="geofence.pricing.SharedAirportFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SharedAirportFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SharedMileageRate" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SharedMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SharedFare" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SharedFare')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SharedMileageThreshold" :options="'floatPos'"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SharedMileageThreshold')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SharedFlat2ndPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SharedFlat2ndPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SharedFlatAddPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SharedFlatAddPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SharedPassengerMileageRate" :options="passenger" class="small-input"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SharedPassengerMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SharedMaxLuggage" :options="luggage" class="small-input"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SharedMaxLuggage')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.SharedDiscountCurrency" @change="updatePricing('SharedDiscountCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.SharedDiscount" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SharedDiscount')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.SharedRoundtripCurrency" @change="updatePricing('SharedRoundtripCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.SharedRoundtrip" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SharedRoundtrip')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td class="table-label">{{ serviceLabel('opoli') }}</td>
            <td v-show="isP2P"></td>
            <td v-show="!isP2P"><vue-autonumeric v-model="geofence.pricing.OpoliAirportFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('OpoliAirportFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.OpoliMileageRate" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('OpoliMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.OpoliFare" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('OpoliFare')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.OpoliMileageThreshold" :options="'floatPos'"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('OpoliMileageThreshold')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.OpoliFlat2ndPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('OpoliFlat2ndPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.OpoliFlatAddPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('OpoliFlatAddPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.OpoliPassengerMileageRate" :options="passenger" class="small-input"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('OpoliPassengerMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.OpoliMaxLuggage" :options="luggage" class="small-input"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('OpoliMaxLuggage')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.OpoliDiscountCurrency" @change="updatePricing('OpoliDiscountCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.OpoliDiscount" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('OpoliDiscount')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.OpoliRoundtripCurrency" @change="updatePricing('OpoliRoundtripCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.OpoliRoundtrip" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('OpoliRoundtrip')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td class="table-label">{{ serviceLabel('black') }}</td>
            <td v-show="isP2P"></td>
            <td v-show="!isP2P"><vue-autonumeric v-model="geofence.pricing.BlackAirportFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('BlackAirportFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.BlackMileageRate" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('BlackMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.BlackFare" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('BlackFare')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.BlackMileageThreshold" :options="'floatPos'"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('BlackMileageThreshold')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.BlackFlat2ndPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('BlackFlat2ndPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.BlackFlatAddPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('BlackFlatAddPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.BlackPassengerMileageRate" :options="passenger" class="small-input"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('BlackPassengerMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.BlackMaxLuggage" :options="luggage" class="small-input"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('BlackMaxLuggage')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.BlackDiscountCurrency" @change="updatePricing('BlackDiscountCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.BlackDiscount" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('BlackDiscount')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.BlackRoundtripCurrency" @change="updatePricing('BlackRoundtripCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.BlackRoundtrip" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('BlackRoundtrip')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td class="table-label">{{ serviceLabel('suv') }}</td>
            <td v-show="isP2P"></td>
            <td v-show="!isP2P"><vue-autonumeric v-model="geofence.pricing.SUVAirportFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SUVAirportFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SUVMileageRate" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SUVMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SUVFare" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SUVFare')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SUVMileageThreshold" :options="'floatPos'"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SUVMileageThreshold')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SUVFlat2ndPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SUVFlat2ndPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SUVFlatAddPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SUVFlatAddPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SUVPassengerMileageRate" :options="passenger" class="small-input"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SUVPassengerMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.SUVMaxLuggage" :options="luggage" class="small-input"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SUVMaxLuggage')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.SUVDiscountCurrency" @change="updatePricing('SUVDiscountCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.SUVDiscount" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SUVDiscount')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.SUVRoundtripCurrency" @change="updatePricing('SUVRoundtripCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.SUVRoundtrip" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('SUVRoundtrip')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td class="table-label">{{ serviceLabel('shuttle') }}</td>
            <td v-show="isP2P"></td>
            <td v-show="!isP2P"><vue-autonumeric v-model="geofence.pricing.PrivateShuttleAirportFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('PrivateShuttleAirportFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.PrivateShuttleMileageRate" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('PrivateShuttleMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.PrivateShuttleFare" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('PrivateShuttleFare')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.PrivateShuttleMileageThreshold" :options="'floatPos'"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('PrivateShuttleMileageThreshold')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.PrivateShuttleFlat2ndPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('PrivateShuttleFlat2ndPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.PrivateShuttleFlatAddPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('PrivateShuttleFlatAddPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.PrivateShuttlePassengerMileageRate" :options="passenger" class="small-input"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('PrivateShuttlePassengerMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.pricing.PrivateShuttleMaxLuggage" :options="luggage" class="small-input"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('PrivateShuttleMaxLuggage')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.PrivateShuttleDiscountCurrency" @change="updatePricing('PrivateShuttleDiscountCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.PrivateShuttleDiscount" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('PrivateShuttleDiscount')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.PrivateShuttleRoundtripCurrency" @change="updatePricing('PrivateShuttleRoundtripCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.PrivateShuttleRoundtrip" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updatePricing('PrivateShuttleRoundtrip')"></vue-autonumeric></td>
          </tr> -->
          <!-- Apply global config for promo start and end date -->
          <!-- <tr class="sub-box">
            <td colspan="3" class="table-label">Discount Date</td>
            <td colspan="3">
              <label class="sub-label">Start</label>
              <date-picker v-model="discountStart" input-class="servicearea-date-input" lang="en" @change="changeDate" class="date-input-block"></date-picker>
            </td>
            <td colspan="3">
              <label class="sub-label">End</label>
              <date-picker v-model="discountEnd" input-class="servicearea-date-input" lang="en" @change="changeDate" class="date-input-block"></date-picker>
            </td>
            <td colspan="3">
              <a :class="{'button cta xsmall block filter-button':true, 'disabled':saveGlobalBtn}" @click="openModal">Apply to others</a>
            </td>
            <td></td>
          </tr>
        </table>
      </div>
    </div> -->

    <!-- <div class="row margin-T">
      <div class="small-12">
        <table class="table">
          <tr>
            <td colspan="7" class="table-title">PROVIDER RATE SETTINGS</td>
          </tr>
          <tr>
            <td></td>
            <td class="table-label">Per Mile<br/>Rate</td>
            <td class="table-label">Base Fee</td>
            <td class="table-label">Bonus Per<br/>Mile Party</td>
            <td class="table-label">Flat 2nd<br/>Pax Fee</td>
            <td class="table-label">Flax Add.<br/>Pax Fee</td>
            <td class="table-label">Discount<br/>Rate</td>
          </tr>
          <tr>
            <td class="table-label">{{ serviceLabel('shared') }}</td>
            <td><vue-autonumeric v-model="geofence.driverPay.SharedProviderMileageRate" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SharedProviderMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.SharedProviderBaseFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SharedProviderBaseFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.sharedBonusPerMile" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SharedProviderBonus')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.SharedProviderFlat2ndPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SharedProviderFlat2ndPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.SharedProviderFlatAddPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SharedProviderFlatAddPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.SharedProviderDiscount" :options="percent"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SharedProviderDiscount')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td class="table-label">{{ serviceLabel('opoli') }}</td>
            <td><vue-autonumeric v-model="geofence.driverPay.OpoliProviderMileageRate" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('OpoliProviderMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.OpoliProviderBaseFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('OpoliProviderBaseFee')"></vue-autonumeric></td>
            <td class="table-label">--</td> -->
            <!--td><vue-autonumeric v-model="geofence.driverPay.OpoliMileageThreshold" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('OpoliMileageThreshold')"></vue-autonumeric></td-->
            <!-- <td><vue-autonumeric v-model="geofence.driverPay.OpoliProviderFlat2ndPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('OpoliProviderFlat2ndPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.OpoliProviderFlatAddPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('OpoliProviderFlatAddPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.OpoliProviderDiscount" :options="percent"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('OpoliProviderDiscount')"></vue-autonumeric></td>
          </tr>
          <tr> -->
            <!-- <td class="table-label">{{ serviceLabel('black') }}</td>
            <td><vue-autonumeric v-model="geofence.driverPay.BlackProviderMileageRate" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('BlackProviderMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.BlackProviderBaseFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('BlackProviderBaseFee')"></vue-autonumeric></td>
            <td class="table-label">--</td> -->
            <!--td><vue-autonumeric v-model="geofence.driverPay.BlackMileageThreshold" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('BlackMileageThreshold')"></vue-autonumeric></td-->
            <!-- <td><vue-autonumeric v-model="geofence.driverPay.BlackProviderFlat2ndPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('BlackProviderFlat2ndPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.BlackProviderFlatAddPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('BlackProviderFlatAddPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.BlackProviderDiscount" :options="percent"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('BlackProviderDiscount')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td class="table-label">{{ serviceLabel('suv') }}</td>
            <td><vue-autonumeric v-model="geofence.driverPay.SUVProviderMileageRate" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SUVProviderMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.SUVProviderBaseFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SUVProviderBaseFee')"></vue-autonumeric></td>
            <td class="table-label">--</td> -->
            <!--td><vue-autonumeric v-model="geofence.driverPay.SUVMileageThreshold" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SUVMileageThreshold')"></vue-autonumeric></td-->
            <!-- <td><vue-autonumeric v-model="geofence.driverPay.SUVProviderFlat2ndPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SUVProviderFlat2ndPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.SUVProviderFlatAddPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SUVProviderFlatAddPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.SUVProviderDiscount" :options="percent"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SUVProviderDiscount')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td class="table-label">{{ serviceLabel('shuttle') }}</td>
            <td><vue-autonumeric v-model="geofence.driverPay.PrivateShuttleProviderMileageRate" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('PrivateShuttleProviderMileageRate')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.PrivateShuttleProviderBaseFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('PrivateShuttleProviderBaseFee')"></vue-autonumeric></td>
            <td class="table-label">--</td> -->
            <!--td><vue-autonumeric v-model="geofence.driverPay.PrivateShuttleMileageThreshold" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('PrivateShuttleMileageThreshold')"></vue-autonumeric></td-->
            <!-- <td><vue-autonumeric v-model="geofence.driverPay.PrivateShuttleProviderFlat2ndPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('PrivateShuttleProviderFlat2ndPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.PrivateShuttleProviderFlatAddPAXFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('PrivateShuttleProviderFlatAddPAXFee')"></vue-autonumeric></td>
            <td><vue-autonumeric v-model="geofence.driverPay.PrivateShuttleProviderDiscount" :options="percent"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('PrivateShuttleProviderDiscount')"></vue-autonumeric></td>
          </tr>
        </table>
      </div>
    </div> -->

    <div class="row margin-T">
      <!-- <div class="small-5 columns padding-R">
        <table class="table">
          <tr>
            <td colspan="5" class="table-title">SERVICE TYPES</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td class="table-label">Curbside</td>
            <td class="table-label">Meet &amp; Greet</td>
            <td class="table-label">Fee</td>
          </tr>
          <tr>
            <td><input type="checkbox" v-model="geofence.services.shared.allowed"
            @change="updateServiceType('shared', 'allowed')" /></td>
            <td class="table-label">{{ serviceLabel('shared') }}</td>
            <td><input type="checkbox" class="center-checkbox" v-model="geofence.services.shared.curbside"
              @change="updateServiceType('shared', 'curbside')" /></td>
            <td><input type="checkbox" class="center-checkbox" v-model="geofence.services.shared.meetAndGreet"
              @change="updateServiceType('shared', 'meetAndGreet')" /></td>
            <td><vue-autonumeric v-model="geofence.services.shared.pickupFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateServiceType('shared', 'pickupFee')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td><input type="checkbox" v-model="geofence.services.opoli.allowed"
            @change="updateServiceType('opoli', 'allowed')" /></td>
            <td class="table-label">{{ serviceLabel('opoli') }}</td>
            <td><input type="checkbox" class="center-checkbox" v-model="geofence.services.opoli.curbside"
              @change="updateServiceType('opoli', 'curbside')" /></td>
            <td><input type="checkbox" class="center-checkbox" v-model="geofence.services.opoli.meetAndGreet"
               @change="updateServiceType('opoli', 'meetAndGreet')"/></td>
            <td><vue-autonumeric v-model="geofence.services.opoli.pickupFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateServiceType('opoli', 'pickupFee')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td><input type="checkbox" v-model="geofence.services.black.allowed"
            @change="updateServiceType('black', 'allowed')" /></td>
            <td class="table-label">{{ serviceLabel('black') }}</td>
            <td><input type="checkbox" class="center-checkbox" v-model="geofence.services.black.curbside"
             @change="updateServiceType('black', 'curbside')" /></td>
            <td><input type="checkbox" class="center-checkbox" v-model="geofence.services.black.meetAndGreet"
             @change="updateServiceType('black', 'meetAndGreet')" /></td>
            <td><vue-autonumeric v-model="geofence.services.black.pickupFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateServiceType('black', 'pickupFee')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td><input type="checkbox" v-model="geofence.services.suv.allowed"
            @change="updateServiceType('suv', 'allowed')" /></td>
            <td class="table-label">{{ serviceLabel('suv') }}</td>
            <td><input type="checkbox" class="center-checkbox" v-model="geofence.services.suv.curbside"
             @change="updateServiceType('suv', 'curbside')" /></td>
            <td><input type="checkbox" class="center-checkbox" v-model="geofence.services.suv.meetAndGreet"
             @change="updateServiceType('suv', 'meetAndGreet')" /></td>
            <td><vue-autonumeric v-model="geofence.services.suv.pickupFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateServiceType('suv', 'pickupFee')"></vue-autonumeric></td>
          </tr>
          <tr>
            <td><input type="checkbox" v-model="geofence.services.shuttle.allowed"
            @change="updateServiceType('shuttle', 'allowed')" /></td>
            <td class="table-label">{{ serviceLabel('shuttle') }}</td>
            <td><input type="checkbox" class="center-checkbox" v-model="geofence.services.shuttle.curbside"
             @change="updateServiceType('shuttle', 'curbside')" /></td>
            <td><input type="checkbox" class="center-checkbox" v-model="geofence.services.shuttle.meetAndGreet"
             @change="updateServiceType('shuttle', 'meetAndGreet')" /></td>
            <td><vue-autonumeric v-model="geofence.services.shuttle.pickupFee" :options="dollar"
                                 v-on:autoNumeric:rawValueModified.native="updateServiceType('shuttle', 'pickupFee')"></vue-autonumeric></td>
          </tr>
        </table>
      </div> -->
      <div class="small-2 columns padding-R padding-L">
        <table class="table">
          <tr>
            <td colspan="2" class="table-title">RSVP TYPES</td>
          </tr>
          <tr>
            <td><input type="checkbox" v-model="geofence.allowASAP" @change="updateRsvpType('allowASAP')" /></td>
            <td class="table-label">ASAP</td>
          </tr>
          <tr>
            <td><input type="checkbox" v-model="geofence.allowFuture" @change="updateRsvpType('allowFuture')" /></td>
            <td class="table-label">Future RSVP</td>
          </tr>
        </table>
      </div>
      <div class="small-2 columns padding-L">
        <table class="table">
          <tr>
            <td colspan="2" class="table-title">LICENSE TYPES</td>
          </tr>
          <tr>
            <td><input type="checkbox" v-model="geofence.allowTNC" @change="updateBooleanField('allowTNC')" /></td>
            <td class="table-label">TNC</td>
          </tr>
          <tr>
            <td><input type="checkbox" v-model="geofence.allowTCP" @change="updateBooleanField('allowTCP')" /></td>
            <td class="table-label">TCP</td>
          </tr>
        </table>
      </div>
      <div class="small-3 columns"></div>
    </div>

    <!-- <div class="row margin-T">
      <div class="small-11 columns">
        <table class="table">
          <tr>
            <td colspan="11" class="table-title">HOLIDAY RATES</td>
          </tr>
          <tr>
            <td class="table-label">Date</td>
            <td colspan="2" class="table-label">{{ serviceLabel('shared') }}</td>
            <td colspan="2" class="table-label">{{ serviceLabel('opoli') }}</td>
            <td colspan="2" class="table-label">{{ serviceLabel('black') }}</td>
            <td colspan="2" class="table-label">{{ serviceLabel('suv') }}</td>
            <td colspan="2" class="table-label">{{ serviceLabel('shuttle') }}</td>
          </tr>
          <tr> -->
            <!--td><datepicker class="geofence-datepicker" v-model="holidayDate" format="MM/dd/yyyy"></datepicker></td-->
            <!-- <td><date-picker v-model="holidayDate" input-class="servicearea-date-input" lang="en"></date-picker></td>
            <td>
              <select v-model="geofence.pricing.SharedHolidayRateCurrency" @change="updatePricing('SharedHolidayRateCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.SharedHolidayRate" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SharedHolidayRate')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.OpoliHolidayRateCurrency" @change="updatePricing('OpoliHolidayRateCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.OpoliHolidayRate" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('OpoliHolidayRate')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.BlackHolidayRateCurrency" @change="updatePricing('BlackHolidayRateCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.BlackHolidayRate" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('BlackHolidayRate')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.SUVHolidayRateCurrency" @change="updatePricing('SUVHolidayRateCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.SUVHolidayRate" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('SUVHolidayRate')"></vue-autonumeric></td>
            <td>
              <select v-model="geofence.pricing.PrivateShuttleHolidayRateCurrency" @change="updatePricing('PrivateShuttleHolidayRateCurrency')">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td><vue-autonumeric v-model="geofence.pricing.PrivateShuttleHolidayRate" :options="oneHundred"
                                 v-on:autoNumeric:rawValueModified.native="updateDriverPay('PrivateShuttleHolidayRate')"></vue-autonumeric></td>
          </tr>
        </table>
      </div>
    </div> -->

    <!-- <div class="row margin-T">
      <div class="small-12 columns">
        <table class="table">
          <tr>
            <td colspan="8" class="table-title">PROMOTIONAL PRICING</td>
          </tr>
          <tr>
            <td colspan="8" v-show="promos.loading">
              <div class="promo-loading">
                <i class="fa fa-spinner fa-spin"></i>
                <span>LOADING PROMOS</span>
              </div>
            </td>
          </tr>
          <tr v-show="!promos.loading && promos.list.length > 0">
            <td class="table-label-header">Service Type</td>
            <td class="table-label-header">Promo Type</td>
            <td class="table-label-header">Flat Rate</td>
            <td class="table-label-header">Base Rate</td>
            <td class="table-label-header">Mileage Rate</td>
            <td class="table-label-header">2nd Pax Fee</td>
            <td class="table-label-header">Add. Pax Fee</td>
            <td></td>
          </tr>
          <tr v-for="(promo, index) in promos.list">
            <td class="table-label">{{ serviceName(promo.serviceId) }}</td>
            <td class="table-label">
              <span v-if="promo.type === 'flat'">Flat Rate</span>
              <span v-else>Discount Mileage Rate</span>
            </td>
            <td class="table-label">
              <span v-if="promo.type === 'flat'">${{ promo.flatRate.toFixed(2) }}</span>
              <span v-else>--</span>
            </td>
            <td class="table-label">
              <span v-if="promo.type === 'discount'">${{ promo.discountBaseRate.toFixed(2) }}</span>
              <span v-else>--</span>
            </td>
            <td class="table-label">
              <span v-if="promo.type === 'discount'">${{ promo.discountMileageRate.toFixed(2) }}</span>
              <span v-else>--</span>
            </td>
            <td class="table-label">
              <span v-if="promo.type === 'flat'">${{ promo.flat2ndPAXFee.toFixed(2) }}</span>
              <span v-else>${{ promo.discount2ndPAXFee.toFixed(2) }}</span>
            </td>
            <td class="table-label">
              <span v-if="promo.type === 'flat'">${{ promo.flatAddPAXFee.toFixed(2) }}</span>
              <span v-else>${{ promo.discountAddPAXFee.toFixed(2) }}</span>
            </td>
            <td class="table-label"><a class="button cta xsmall error" href="javascript:;" @click="removePromo(index)">REMOVE</a></td>
          </tr>
          <tr v-show="!promos.loading">
            <td colspan="8" class="promo-pricing">
              <a href="javascript:;" class="button cta xsmall success" @click="showPromoForm">ADD ANOTHER SERVICE</a>
            </td>
          </tr>
        </table>
      </div>
    </div> -->
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import VueAutonumeric from 'vue-autonumeric'
import services from '@/modules/api/services'
export default {
  name: 'geofence-fields-servicearea',
  props: ['geofence'],
  components: { DatePicker, VueAutonumeric },
  data () {
    return {
      dollar: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '99.99'
      },
      percent: {
        currencySymbol: ' %',
        currencySymbolPlacement: 's',
        minimumValue: '0',
        maximumValue: '100'
      },
      passenger: {
        minimumValue: '0',
        maximumValue: '9',
        decimalPlaces: 0
      },
      oneHundred: {
        minimumValue: '0',
        maximumValue: '100'
      },
      luggage: {
        minimumValue: '0',
        maximumValue: '18',
        decimalPlaces: 0
      },
      promos: {
        loading: false,
        list: []
      }
    }
  },
  computed: {
    saveGlobalBtn () { return this.$store.state.geofences.services.saveBtn },
    isP2P () {
      let self = this
      let geofences = self.$store.state.geofences.geofences.items
      let index = geofences.findIndex(x => x.id === self.geofence.id)
      if (index < 0) {
        return false
      }
      return geofences[index].isP2P
    },
    holidayDate: {
      get () {
        let self = this
        if (!self.geofence) {
          return null
        }

        let date = moment(self.geofence.holidayDate, 'YYYY-MM-DD')
        return date.toDate()
      },
      set (value) {
        let self = this
        let date = moment(value)
        self.geofence.holidayDate = date.format('YYYY-MM-DD')
        self.$store.commit('geofences/setGeofenceField', {
          id: self.geofence.id,
          field: 'holidayDate',
          value: self.geofence.holidayDate
        })
      }
    },
    discountStart: {
      get () {
        let self = this
        if (!self.geofence) {
          return null
        }
        let date = moment(self.geofence.promotionStartDate, 'YYYY-MM-DD HH:mm:ss Z')
        return date.toDate()
      },
      set (value) {
        let self = this
        let date = moment(value)
        self.geofence.promotionStartDate = date.format('YYYY-MM-DD HH:mm:ss Z')
        self.$store.commit('geofences/setGeofenceField', {
          id: self.geofence.id,
          field: 'promotionStartDate',
          value: self.geofence.promotionStartDate
        })
      }
    },
    discountEnd: {
      get () {
        let self = this
        if (!self.geofence) {
          return null
        }
        let date = moment(self.geofence.promotionEndDate, 'YYYY-MM-DD HH:mm:ss Z')
        return date.toDate()
      },
      set (value) {
        console.log(value)
        let self = this
        let date = moment(value)
        self.geofence.promotionEndDate = date.format('YYYY-MM-DD HH:mm:ss Z')
        self.$store.commit('geofences/setGeofenceField', {
          id: self.geofence.id,
          field: 'promotionEndDate',
          value: self.geofence.promotionEndDate
        })
      }
    },
    promoRefreshID () { return this.$store.state.geofences.promo.refreshID }
  },
  methods: {
    changeDate () {
      let self = this
      self.$store.commit('geofences/setSaveBtn', false)
    },
    openModal () {
      let self = this
      self.$store.commit('geofences/setShowServiceAreaModal', true)
      self.$store.commit('geofences/setStartDatePromo', self.geofence.promotionStartDate)
      self.$store.commit('geofences/setEndDatePromo', self.geofence.promotionEndDate)
      self.$store.commit('geofences/setServiceAreaID', self.geofence.id)
    },
    loadPromos () {
      let self = this
      self.promos.loading = true
      self.promos.list = []
      self.$sdk.get('/geofences/' + self.geofence.id + '/promos', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.promos.loading = false
        if (r.error) {
          return
        }
        self.promos.list = r.list
      })
    },
    showPromoForm () {
      this.$store.commit('geofences/setGeofencePromoShow', true)
      this.$store.commit('geofences/setGeofencePromo', this.geofence)
      this.$store.commit('geofences/setGeofencePromoList', this.promos.list)
    },
    removePromo (index) {
      let self = this
      let promo = self.promos.list[index]
      let promos = []
      for (let i = 0; i < self.promos.list.length; i++) {
        if (i === index) {
          continue
        }
        promos.push(self.promos.list[i])
      }
      self.promos.list = promos
      self.$sdk.delete('/geofences/' + self.geofence.id + '/promos/' + promo.id, {
        token: self.$store.state.session.sessionToken
      }, r => {
        console.log('PROMO REMOVED', r)
      })
    },
    updateRsvpType (field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field] ? 1 : 0
      })
      let fieldName = 'resTypeFuture'
      if (field === 'allowASAP') {
        fieldName = 'resTypeASAP'
      }
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: fieldName,
        value: this.geofence[field] ? 1 : 0
      })
    },
    updateBooleanField (field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field] ? 1 : 0
      })
    },
    updatePricing (field) {
      this.$store.commit('geofences/setGeofencePricing', {
        id: this.geofence.id,
        field: field,
        value: this.geofence.pricing[field]
      })
    },
    updateDriverPay (field) {
      let value = this.geofence.driverPay[field]
      if (field === 'SharedProviderBonus') {
        value = this.geofence.sharedBonusPerMile
      }
      this.$store.commit('geofences/setGeofenceDriverPay', {
        id: this.geofence.id,
        field: field,
        value: value
      })
    },
    updateServiceType (serviceType, field) {
      this.$store.commit('geofences/setGeofenceServiceType', {
        id: this.geofence.id,
        field: field,
        serviceType: serviceType,
        value: this.geofence.services[serviceType][field]
      })
    },
    serviceName (id) {
      let services = CONFIG.serviceId
      for (let prop in services) {
        if (!services.hasOwnProperty(prop)) {
          continue
        }

        if (services[prop] !== id) {
          continue
        }

        return this.serviceLabel(prop)
      }
    },
    serviceLabel (code) { return services.getServiceName(code) }
  },
  watch: {
    promoRefreshID (value) {
      if (value !== this.geofence.id) {
        return
      }
      this.loadPromos()
    }
  },
  mounted () {
    // this.loadPromos()
  }
}
</script>

<style lang="scss" scoped>

.table {
  border: 1px solid #0D79F2;
  margin: 10px 0;
  border-collapse: collapse;
  width: 100%;

  .table-label {
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
  }
  .sub-box{
    border-top: 1px solid #0D79F2;
    background: #f3f3f3;

    td{ padding: 10px 4px!important; }
    .sub-label{
      display: block;
      font-size: 11px;
      color: #888;
      line-height: 1;
      margin: 0 0 3px 2px;
    }
    .date-input-block{
      display: block;
      margin-bottom: 2px;
    }
    .button{ margin-top: 10px; }
  }

  & .table-label-header {
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    font-weight: 700;
  }

  & input {
    margin: 0;
    padding: 5px;
    font-size: 13px;
    text-align: right;

    &[type="text"],
    &[type="number"],
    &[type="date"]{
      margin: 0 auto;
      width: 60px;

      &.small-input {
        width: 60px;
      }

      &.date-input {
        width: 150px;
        margin-top: 0 !important;
      }
    }

    &[type="checkbox"] {
      margin: 0 7px;

      &.center-checkbox {
        width: 12px;
        margin: 0 auto;
      }
    }
  }

  & select {
    font-size: 13px;
    height: 31px;
    outline: 0;
    padding: 5px;
    display: inline-block;
    width: 50px;
    border-color: rgba(0,0,0,0.15);
    background-color: #fff;
    border-radius: 3px;
  }

  & td {
    padding: 7px 4px;
  }

  & .table-title {
    background-color: #0D79F2;
    font-size: 13px;
    color: #fff;
    font-weight: 700;
    padding: 8px 15px;
  }

  & .promo-pricing {
    text-align: center;
    padding: 15px 0;
    border-top: 1px solid #0D79F2;
  }
}
.input-field {
  font-size: 14px;

  & label {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
  }

  & input, & textarea {
    margin-top: 0;
    padding: 7px 10px;
  }

  & textarea {
    resize: none;
    height: 100px;
  }
}

.checkbox-input {
  & > * {
    display: inline-block;
    vertical-align: middle;
    width: auto;
  }
  & input {
    margin-top: 0;
  }
  & span {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
    height: 16px;
    margin-left: 3px;
  }
}

.promo-loading {
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  padding: 15px;
}

.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }
.margin-T { margin-top: 15px; }


@media only screen and (max-width: 430px) {
  .padding-R, .padding-L {
    padding: 0;
  }

  .small-2, .small-5, .small-6, .small-3, .small-4, .small-8 {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/GeofenceFieldsServiceArea.vue